import { render, staticRenderFns } from "./clientTypeIdInput.vue?vue&type=template&id=815645dc&"
import script from "./clientTypeIdInput.vue?vue&type=script&lang=js&"
export * from "./clientTypeIdInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports